/**
 * Racines de portée du runtime (ADR-048 §4). Une référence commence toujours par l'une d'elles ;
 * toute autre racine est refusée à la publication.
 */
export const ROOTS = {
    inputs: 'inputs',
    state: 'state',
    variables: 'variables',
    event: 'event',
    record: 'record',
    item: 'item',
    context: 'context',
    theme: 'theme',
};
/** Clés de `$context` : ce que l'hôte expose, jamais un secret ni un jeton de session. */
export const CONTEXT_KEYS = new Set(['tenant_id', 'entity_id', 'site_id', 'identity_id', 'locale', 'route', 'surface']);
/** Racines lisibles par position (58 §5-§7, §13). */
export const VARIABLE_ROOTS = ['inputs', 'state', 'variables', 'record', 'context', 'theme'];
export const PROPERTY_ROOTS = ['inputs', 'state', 'variables', 'record', 'context', 'theme'];
export const ACTION_ROOTS = ['inputs', 'state', 'variables', 'record', 'context', 'theme', 'event'];
const REFERENCE = /^\$([a-z][a-z0-9_]*)((?:\.[a-z0-9_]+)*)$/;
export function parseReference(text) {
    const match = REFERENCE.exec(text);
    if (match === null)
        return null;
    return { root: match[1], segments: match[2].split('.').filter((segment) => segment !== '') };
}
/**
 * Références citées par une expression canonique, `$literal` exclu (un littéral n'est jamais lu
 * comme une référence). La forme a déjà été validée par l'évaluateur du Core.
 */
export function collectReferences(expression, out = []) {
    if (typeof expression === 'string') {
        if (expression.startsWith('$')) {
            const reference = parseReference(expression);
            if (reference !== null)
                out.push(reference);
        }
        return out;
    }
    if (Array.isArray(expression)) {
        for (const entry of expression)
            collectReferences(entry, out);
        return out;
    }
    if (expression === null || typeof expression !== 'object')
        return out;
    for (const [key, value] of Object.entries(expression)) {
        if (key === '$literal')
            continue;
        if (key === '$switch' && value !== null && typeof value === 'object') {
            const spec = value;
            if (Array.isArray(spec.branches))
                for (const branch of spec.branches)
                    collectReferences(branch, out);
            if ('default' in spec)
                collectReferences(spec.default, out);
            continue;
        }
        if (key === '$fn' && value !== null && typeof value === 'object') {
            collectReferences(value.args, out);
            continue;
        }
        collectReferences(value, out);
    }
    return out;
}
//# sourceMappingURL=scope.js.map